import { render, staticRenderFns } from "./InactiveCategory.vue?vue&type=template&id=4bf9d257&scoped=true&"
import script from "./InactiveCategory.vue?vue&type=script&lang=js&"
export * from "./InactiveCategory.vue?vue&type=script&lang=js&"
import style0 from "./InactiveCategory.vue?vue&type=style&index=0&id=4bf9d257&prod&lang=scss&scoped=true&"
import style1 from "./InactiveCategory.vue?vue&type=style&index=1&id=4bf9d257&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf9d257",
  null
  
)

export default component.exports